/*
 * @Descripttion: hqx
 * @version: 1.0.0
 * @Author: zhuxuxi
 * @Date: 2023-05-09 17:40:50
 * @LastEditTime: 2023-08-11 10:00:52
 */
import Vue from 'vue'
// 初始化样式
import 'normalize.css'
import './styles/index.scss'
// 引入lethe-map样式
import '@wushi/lethe-map/lib/lethe-map.css'
import LetheMap from '@wushi/lethe-map'

// 按需引入ant design vue
import antdvue from './utils/register-antdvue'
import 'ant-design-vue/lib/spin/style/css'

// 引入svg
import './assets/icon'

import '@/utils/letheUI'

import './utils/MovingMarker'
// 引入mockjs
// import './mock/mock'

import App from './App.vue'
import router from '@/router/index'
import store from './store'

import { axiosQuick } from '@idev0/vue-axios'
import VueCompositionAPI from '@vue/composition-api'
import data from '@/api/api'
// 引入dayjs
import * as dayjs from 'dayjs'
import VueI18n from 'vue-i18n'
import { message } from 'ant-design-vue'
// import '@/utils/rem.js'
// import 'amfe-flexible'
Vue.config.productionTip = false
Vue.prototype.$dayjs = dayjs
Vue.prototype.$message = message
Vue.use(VueCompositionAPI).use(LetheMap).use(antdvue)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    zh: require('./lang/zh'),
    en: require('./lang/en')
  }
})
const config = {
  globalOptions: {
    // baseURL: process.env.NODE_ENV === 'development' ? '' : 'http://code01.gdhqx.com:1306/'
    // baseURL: 'http://code01.gdhqx.com:1306/'
  },
  apiConfig: data.apiConfig, // 也可以直接通过url获取，url: '/web/config/system_api.json',
  router,
  paramSign: true,
  requestIntercept(config) {
    return config
  }
}

axiosQuick(config).then(() => {
  new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
  }).$mount('#app')
})

// 延迟加载字体文件
setTimeout(() => import(/* webpackChunkName: "fonts" */ './styles/font.scss'), 1000 * 5)
